export default __webpack_public_path__ + "static/media/mec-6.cf52734d.png";